const mutations = {
  setVehicle(state, data) {
    state.vehicleEdit = data
  },
  setDeleteVehicle(state, data) {
    state.vehicleDelete = data
  }
}

export default mutations